'use client';
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/dine.module.scss";
import useDeviceType from "@/app/utils/useDeviceType";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
import https from "https";
import { useState, useEffect } from "react";
import CodeDisplay from "@/app/utils/content";
import Loading from "./loading";

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getPageData() {
  const query = `
{
  pageData: pageBy(id: "cG9zdDoxNTA=") {
    pageBan {
      bannerText
      bannerSlider {
        desktopImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
    content
  }
}
  `;

  const res = await fetch(
    `${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`,
    {
      httpsAgent: agent,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({query}),
      next: {
        revalidate: 60,
      },
    }
  );

  const { data } = await res.json();

  return data;
}

export default function PrivacyPolicy() {

  const deviceType = useDeviceType();

  const [page_banner_text, setPageBannerText] = useState("");
  const [page_banner_sliders, setPageBannerSliders] = useState([]);

  const [page_content, setPageContent] = useState(null);

  const [pre_loader_enabled, setPreLoaderEnable] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const page = await getPageData();
      if(page){
       // console.log(page);
        if(page.pageData){

          if(page.pageData.pageBan){
            if(page.pageData.pageBan.bannerText){
              setPageBannerText(page.pageData.pageBan.bannerText);
            }
            if(page.pageData.pageBan.bannerSlider){
              setPageBannerSliders(page.pageData.pageBan.bannerSlider);
            }
          }
          if(page.pageData.content){
            setPageContent(page.pageData.content);
          }
        }
        setPreLoaderEnable(false);
      }
    };

    fetchData();
    return () => {};
  }, []);


  useEffect( () => {
    (
      async () => {
          const LocomotiveScroll = (await import('locomotive-scroll')).default
          const locomotiveScroll = new LocomotiveScroll();
      }
    )()
  }, [])

  // if (pre_loader_enabled) {
  //   return <Loading />;
  // }

  return (
    <>
       {page_banner_sliders && page_banner_sliders.length !== 0 &&(
      <section className="inner-banner position-relative">
        <Carousel fade className='page-inner-carousel'>
        {page_banner_sliders.map((banner_img, index) => {

          let imgurl = '';

          if(banner_img.desktopImage){
            if(banner_img.desktopImage.node){
              if(banner_img.desktopImage.node.mediaItemUrl){
                imgurl = banner_img.desktopImage.node.mediaItemUrl;
              }
            }
          }

          return(
          <Carousel.Item key={index}>
            <Image
              className={styles.banner_section_main_img}
              src={imgurl}
              width={deviceType !== "mobile" ? 1920 : 400}
              height={deviceType !== "mobile" ? 1080 : 800}
              alt="Banner Image"
              priority
              quality={deviceType !== "mobile" ? 50 : 80}
            />
          </Carousel.Item>
          );}
          )}
        </Carousel>
        <div className='inner-banner-text'>
          <h2 className='all-caps section-heading-large section-heading--yellow'>{page_banner_text}</h2>
        </div>
      </section>
      )}
      {page_banner_sliders && page_banner_sliders.length === 0 &&(
      <section className="bg-dark-green green-mesh  inner-banner-text-wrap position-relative">
        <div className='inner-banner-text z-top'>
          <h1 className='all-caps section-heading section-heading--yellow m-0 heading-padding'>{page_banner_text}</h1>
        </div>
      </section>
      )}
      {page_content &&(
      <section className="section-padding-bottom bg-dark-green green-mesh ">
        <div className="middle-wrap z-top middle-wrap-single">
          <div className="the_content_div">
            <CodeDisplay code={page_content} />
          </div>
        </div>
      </section>
      )}
    </>
  )
}
